import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAvatar,{class:_vm.avatarClass,attrs:{"size":_vm.size,"tile":_vm.tile,"icon":""}},[(_vm.src)?_c(VImg,{attrs:{"src":_vm.src,"alt":_vm.alt,"contain":""}}):_c(VIcon,{staticClass:"avatar-placeholder"},[_vm._v(_vm._s(_vm.placeholder))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }